/**
 * Converts a project title to a URL-friendly slug.
 * e.g. "Smart Industrial Maintenance System : AI-Powered..." → "smart-industrial-maintenance-system-ai-powered-..."
 */
export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s*:\s*/g, '-')        // replace " : " with "-"
    .replace(/&/g, 'and')            // replace & with 'and'
    .replace(/[^\w\s-]/g, '')        // remove non-word chars (except spaces and hyphens)
    .replace(/\s+/g, '-')            // replace spaces with hyphens
    .replace(/-+/g, '-')             // collapse multiple hyphens
    .replace(/^-+|-+$/g, '');        // trim leading/trailing hyphens
};

/**
 * Find a project by its slug from the projects array.
 */
export const getProjectBySlug = (projects, slug) => {
  return projects.find((p) => slugify(p.title) === slug);
};
